/**
 * Hyprism Theme - Features Module
 * Quick View, Quick Add, Sticky Add-to-Cart
 */

/* ============================================
   QUICK ADD
   ============================================ */
(function() {
  /* ── Helper: add variant to cart via AJAX ──────────────────── */
  function addToCart(variantId, quantity, btn) {
    btn.dataset.loading = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      delete btn.dataset.loading;
      if (data.id) {
        /* Trigger cart drawer open if available, else update count */
        var event = new CustomEvent('ne:cart-updated', { bubbles: true, detail: { variantId: variantId } });
        document.dispatchEvent(event);
        /* Visual feedback */
        btn.classList.add('ne-quick-add-btn--done');
        setTimeout(function() { btn.classList.remove('ne-quick-add-btn--done'); }, 1400);
      }
    })
    .catch(function() { delete btn.dataset.loading; });
  }

  /* ── Find variant matching current option selections ─────── */
  function findVariant(variantsJson, selectedOptions) {
    return variantsJson.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
    }) || null;
  }

  /* ── Delegate: single-variant quick add ─────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add-single]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.variantId, 1, btn);
  });

  /* ── Delegate: toggle popover ─────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add-toggle]');
    if (!btn) return;
    e.stopPropagation();
    /* Toggle + popover are siblings inside the same card wrapper in every
       context (product card, hotspot, bento), so resolve the popover from
       the button's own parent — not a context-specific wrapper class. */
    var wrap = btn.parentNode;
    var popover = wrap && wrap.querySelector('[data-quick-add-popover]');
    if (!popover) return;

    var isOpen = !popover.hidden;
    /* Close all other open popovers first */
    document.querySelectorAll('[data-quick-add-popover]:not([hidden])').forEach(function(p) {
      p.hidden = true;
      var b = p.parentNode && p.parentNode.querySelector('[data-quick-add-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      popover.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  /* ── Delegate: swatch selection in popover ─────────────────── */
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-option-value]');
    if (!swatch || !swatch.closest('[data-quick-add-popover]')) return;
    var group = swatch.closest('.ne-quick-add-popover__swatches');
    if (!group) return;
    group.querySelectorAll('.ne-quick-add-popover__swatch--selected').forEach(function(s) {
      s.classList.remove('ne-quick-add-popover__swatch--selected');
    });
    swatch.classList.add('ne-quick-add-popover__swatch--selected');
    /* Print the chosen colour name next to the dots (user 2026-05-24). */
    if (group.classList.contains('ne-quick-add-popover__swatches--color')) {
      var nameEl = group.parentNode.querySelector('[data-color-name]');
      if (nameEl) nameEl.textContent = swatch.getAttribute('data-option-value') || '';
    }
  });

  /* ── Delegate: submit from popover ─────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add-submit]');
    if (!btn) return;
    var popover = btn.closest('[data-quick-add-popover]');
    if (!popover) return;

    var variantsJson;
    try { variantsJson = JSON.parse(btn.dataset.variantsJson); } catch(err) { return; }

    /* Collect selected option values in order */
    var selectedOptions = [];
    popover.querySelectorAll('.ne-quick-add-popover__option').forEach(function(optEl) {
      var sel = optEl.querySelector('.ne-quick-add-popover__swatch--selected');
      selectedOptions.push(sel ? sel.dataset.optionValue : '');
    });

    var variant = findVariant(variantsJson, selectedOptions);
    if (!variant || !variant.available) {
      btn.textContent = btn.dataset.unavailableLabel || 'Nicht verfügbar';
      return;
    }

    addToCart(variant.id, 1, btn);
    /* Close popover after add */
    popover.hidden = true;
    var t = popover.parentNode && popover.parentNode.querySelector('[data-quick-add-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  });

  /* ── Close popover on outside click ─────────────────────────── */
  document.addEventListener('click', function(e) {
    /* Keep it open when the click landed on a toggle or anywhere inside a
       popover (swatch select / add-to-cart) — context-agnostic, no wrapper
       class assumption (fixes swatch clicks closing it in hotspot/bento). */
    if (e.target.closest('[data-quick-add-popover], [data-quick-add-toggle]')) return;
    document.querySelectorAll('[data-quick-add-popover]:not([hidden])').forEach(function(p) {
      p.hidden = true;
      var b = p.parentNode && p.parentNode.querySelector('[data-quick-add-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── ne:cart-updated fallback for pages without the cart drawer
        (e.g. /cart). The drawer snippet has its own listener that
        does refresh + open; if NECart exists we let it handle this. */
  document.addEventListener('ne:cart-updated', function() {
    if (window.NECart) return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.ne-header__cart-count, [data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          /* Toggle the --hidden class (its display:none beats an empty inline
             display, which left the badge hidden after the first add — user
             2026-05-24). */
          el.classList.toggle('ne-header__cart-count--hidden', cart.item_count === 0);
          el.style.display = '';
        });
      });
  });

  /* ── Drawer disabled: AJAX the PDP add instead of navigating to /cart ──
     When the cart drawer is off, the product form would normally POST and
     redirect to /cart. Intercept it so the customer stays on the page and
     keeps shopping — only the header counter updates. When the drawer IS on,
     window.NECart handles the submit, so we bail (user 2026-05-24). */
  document.addEventListener('submit', function(e) {
    if (window.NECart) return;
    var form = e.target;
    if (!form || !form.matches) return;
    if (!form.matches('[data-product-form] form, form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [data-add-to-cart]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && (data.id || data.items)) {
          document.dispatchEvent(new CustomEvent('ne:cart-updated', { detail: { item: data } }));
        }
      })
      .catch(function() {})
      .then(function() { if (btn) btn.removeAttribute('aria-busy'); });
  });
})();


/* ============================================
   CART ADD ANIMATION — badge plop + fly-to-cart
   (opt-in via Theme → Effects, body[data-ne-cart-anim="1"])
   ============================================ */
(function () {
  if (document.body.getAttribute('data-ne-cart-anim') !== '1') return;

  function cartIcon() { return document.querySelector('.ne-header__cart'); }

  /* "Plop" the cart ICON (its SVG animates — far more visible than the tiny
     count badge) whenever the cart updates, in the chosen style. */
  function bumpCart() {
    document.querySelectorAll('.ne-header__cart').forEach(function (el) {
      el.classList.remove('ne-cart-bumping');
      void el.offsetWidth; /* reflow so the animation restarts on repeat adds */
      el.classList.add('ne-cart-bumping');
    });
  }
  document.addEventListener('ne:cart-updated', function () { setTimeout(bumpCart, 80); });
  document.addEventListener('animationend', function (e) {
    if (e.animationName && e.animationName.indexOf('ne-cart-') === 0) {
      var icon = e.target.closest && e.target.closest('.ne-header__cart');
      if (icon) icon.classList.remove('ne-cart-bumping');
    }
  });

  /* Fly-to-cart "ghost" on Add-to-cart click. Skipped for reduced motion or
     when the Web Animations API is unavailable. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || typeof Element.prototype.animate !== 'function') return;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart], [data-quick-add-single]');
    if (!btn || btn.disabled) return;
    var icon = cartIcon();
    if (!icon) return;

    var scope = btn.closest('.ne-product, .ne-product-card, .ne-quick-view-section, [data-product-card], form') || document;
    var srcImg = scope.querySelector('.ne-product__media-img, .ne-product-card__image, .ne-qv__primary img, .ne-block-image__img, img');
    var hasImg = srcImg && srcImg.getBoundingClientRect().width > 12;
    var startRect = hasImg ? srcImg.getBoundingClientRect() : btn.getBoundingClientRect();

    var size = 64;
    var ghost;
    if (hasImg) {
      ghost = document.createElement('img');
      ghost.src = srcImg.currentSrc || srcImg.src;
    } else {
      ghost = document.createElement('span');
      ghost.style.background = 'var(--ne-scheme-accent, #6366f1)';
    }
    ghost.className = 'ne-cart-fly';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    ghost.style.left = (startRect.left + startRect.width / 2 - size / 2) + 'px';
    ghost.style.top = (startRect.top + startRect.height / 2 - size / 2) + 'px';
    document.body.appendChild(ghost);

    var iconRect = icon.getBoundingClientRect();
    var dx = (iconRect.left + iconRect.width / 2) - (startRect.left + startRect.width / 2);
    var dy = (iconRect.top + iconRect.height / 2) - (startRect.top + startRect.height / 2);

    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 60) + 'px) scale(0.55)', opacity: 0.95, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)', opacity: 0.15, offset: 1 }
    ], { duration: 750, easing: 'cubic-bezier(0.5, -0.2, 0.7, 1)' });
    anim.onfinish = function () { ghost.remove(); };
    anim.oncancel = function () { ghost.remove(); };
  }, true);
})();


/* ============================================
   STICKY ADD TO CART
   ============================================ */
(function() {
  var stickyBar = document.querySelector('[data-sticky-atc]');
  if (!stickyBar) return;

  var mainAddBtn = document.querySelector('[data-add-to-cart]');
  if (!mainAddBtn) return;

  var variantIdInput = stickyBar.querySelector('[data-sticky-variant-id]');
  var priceEl = stickyBar.querySelector('[data-sticky-price]');
  var addBtn = stickyBar.querySelector('[data-sticky-add-btn]');

  /* Show/hide based on scroll */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      stickyBar.hidden = false;
      stickyBar.classList.toggle('ne-sticky-atc--visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(mainAddBtn);

  /* Sync variant selection from sticky bar */
  var stickySelects = stickyBar.querySelectorAll('[data-sticky-option]');
  stickySelects.forEach(function(select) {
    select.addEventListener('change', function() {
      /* Sync with main product form */
      var mainSection = document.querySelector('[data-product-section]');
      if (!mainSection) return;

      var optionIndex = select.dataset.stickyOption;
      var mainInputs = mainSection.querySelectorAll('[data-option-index="' + optionIndex + '"]');
      mainInputs.forEach(function(input) {
        if (input.value === select.value) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      var mainSelect = mainSection.querySelector('.ne-product__select[data-option-index="' + optionIndex + '"]');
      if (mainSelect) {
        mainSelect.value = select.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  /* Listen for variant changes on main form to update sticky bar */
  var mainVariantSelect = document.querySelector('[data-variant-id-select]');
  if (mainVariantSelect) {
    var mutationObserver = new MutationObserver(function() {
      if (variantIdInput) variantIdInput.value = mainVariantSelect.value;
    });
    mutationObserver.observe(mainVariantSelect, { attributes: true, attributeFilter: ['value'] });

    mainVariantSelect.addEventListener('change', function() {
      if (variantIdInput) variantIdInput.value = mainVariantSelect.value;
    });
  }
})();

/* ============================================================
   SOCIAL CUSTOM ICON COLORIZER (v2 — mask approach)
   Replaces custom icon <img> elements with <span> using CSS mask-image
   + background-color: currentColor. This makes custom icons inherit the
   exact same color as built-in SVG icons (which use fill="currentColor").
   CSS filter rules in critical.css / css-variables.liquid only target img
   elements, so the converted spans are not affected.
   ============================================================ */
(function() {
  var SELECTOR = 'img.ne-footer__social-custom-icon, img.social-icons__custom-img, img.ne-footer-social__icon-img';

  function applyIconMask() {
    document.querySelectorAll(SELECTOR).forEach(function(img) {
      var src = img.src;
      if (!src) return;
      var span = document.createElement('span');
      span.className = img.className;
      var alt = img.getAttribute('alt');
      if (alt) span.setAttribute('title', alt);
      span.setAttribute('aria-hidden', 'true');
      var quoted = JSON.stringify(src); /* produces "url" with proper escaping */
      span.style.cssText =
        'background-color:currentColor;' +
        '-webkit-mask-image:url(' + quoted + ');' +
        'mask-image:url(' + quoted + ');' +
        '-webkit-mask-size:contain;' +
        'mask-size:contain;' +
        '-webkit-mask-repeat:no-repeat;' +
        'mask-repeat:no-repeat;' +
        '-webkit-mask-position:center;' +
        'mask-position:center;';
      img.parentNode.replaceChild(span, img);
    });
  }

  document.addEventListener('DOMContentLoaded', applyIconMask);
  document.addEventListener('shopify:section:load', applyIconMask);
})();

/* ============================================
   BRAND CAROUSEL (infinite-scroll marquee)
   Used by blocks/slider.liquid — any element
   with [data-brand-carousel] is auto-initialized.
   ============================================ */
(function() {
  /* A clone is a decorative duplicate: it carries aria-hidden, so a screen
     reader does not know it exists. Without tabindex="-1" its links stay in the
     tab order, and a keyboard user walks through several copies of the same
     brand link that no assistive technology announces (WCAG 4.1.2).

     NOT `inert` like the two sticky bars: those are pushed out of the viewport,
     the clones are VISIBLE — in a marquee it is usually a clone under the
     pointer. `inert` would take the link away from mouse users too. tabindex
     removes only the tab stop and leaves the click intact. */
  const FOCUSABLE = 'a[href], area[href], button, input, select, textarea, iframe, [tabindex]';

  function dropTabStops(root) {
    root.querySelectorAll(FOCUSABLE).forEach((el) => el.setAttribute('tabindex', '-1'));
  }

  function restoreTabStops(root) {
    root.querySelectorAll('[tabindex="-1"]').forEach((el) => el.removeAttribute('tabindex'));
  }

  class BrandCarousel {
    constructor(el) {
      this.container = el;
      this.track = el.querySelector('[data-brand-track]');
      if (!this.track || this.track.children.length === 0) return;

      this.speed = parseFloat(el.dataset.speed) || 40;

      this.originals = Array.from(this.track.children).map((node) => {
        /* In lockstep with the aria-hidden reset: if a re-init ever captured a
           clone as an original, it must become reachable again. */
        node.removeAttribute('aria-hidden');
        restoreTabStops(node);
        return node;
      });

      this.setup();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.setup(), 200);
      });
    }

    setup() {
      this.waitForReady().then(() => this.rebuild());
    }

    waitForReady() {
      const imgs = this.originals.flatMap((n) =>
        n.tagName === 'IMG' ? [n] : Array.from(n.querySelectorAll('img'))
      );
      const pending = imgs.filter((img) => !img.complete || img.naturalWidth === 0);
      const imgPromise = pending.length === 0
        ? Promise.resolve()
        : Promise.all(pending.map((img) => new Promise((resolve) => {
            img.addEventListener('load',  resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          })));
      const fontPromise = (document.fonts && document.fonts.ready)
        ? document.fonts.ready
        : Promise.resolve();
      return Promise.all([imgPromise, fontPromise]);
    }

    waitForClones(nodes) {
      const imgs = nodes.flatMap((n) =>
        n.tagName === 'IMG' ? [n] : Array.from(n.querySelectorAll('img'))
      );
      const pending = imgs.filter((img) => !img.complete || img.naturalWidth === 0);
      if (pending.length === 0) return Promise.resolve();
      return Promise.all(pending.map((img) => new Promise((resolve) => {
        img.addEventListener('load',  resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      })));
    }

    rebuild() {
      /* Reset */
      while (this.track.firstChild) this.track.removeChild(this.track.firstChild);
      this.originals.forEach((n) => this.track.appendChild(n));

      /* Append first clone set so we can measure setWidth PRECISELY via
         getBoundingClientRect (fractional px, no rounding). */
      const firstClones = this.originals.map((item) => {
        const c = item.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        dropTabStops(c);
        c.removeAttribute('data-shopify-editor-block');
        this.track.appendChild(c);
        return c;
      });

      this.waitForClones(firstClones).then(() => {
        /* Force a reflow before measuring. */
        void this.track.offsetWidth;

        /* Theme-block children sit inside `<div class="shopify-block">`
           wrappers with `display: contents`. Such wrappers have no
           principal box, so getBoundingClientRect returns zeros — measure
           the inner `.ne-brand-item` instead when present. */
        const measure = (node) => {
          const inner = node.querySelector ? node.querySelector('.ne-brand-item') : null;
          return (inner || node).getBoundingClientRect();
        };
        const rOrig = measure(this.originals[0]);
        const rClone = measure(firstClones[0]);
        const setWidth = rClone.left - rOrig.left;
        if (setWidth <= 0) return;
        this.setWidth = setWidth;

        /* Top up with more full clone sets until the track covers at least
           2× viewport (so the wrap boundary sits offscreen). */
        const viewportWidth = this.container.offsetWidth;
        const targetTrackWidth = viewportWidth * 2 + setWidth;
        let safety = 20;
        while (this.track.scrollWidth < targetTrackWidth && safety-- > 0) {
          this.originals.forEach((item) => {
            const c = item.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            dropTabStops(c);
            c.removeAttribute('data-shopify-editor-block');
            this.track.appendChild(c);
          });
        }

        /* Publish and force-restart the keyframe animation so the new
           set-width aligns the iteration boundary cleanly. */
        const duration = setWidth / this.speed;
        this.container.style.setProperty('--ne-bs-set-width', setWidth + 'px');
        this.container.style.setProperty('--ne-bs-duration', duration + 's');
        this.track.style.animation = 'none';
        void this.track.offsetWidth;
        this.track.style.animation = '';
      });
    }
  }

  function initBrandCarousels(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-brand-carousel]').forEach((el) => {
      if (!el._brandCarousel) el._brandCarousel = new BrandCarousel(el);
    });
  }

  if (document.readyState === 'complete') {
    initBrandCarousels();
  } else {
    window.addEventListener('load', () => initBrandCarousels());
  }

  document.addEventListener('shopify:section:load', (e) => initBrandCarousels(e.target));
  document.addEventListener('shopify:block:load', (e) => initBrandCarousels(e.target));
})();

/* Generic slider edge-detector: sets [data-edge="start" | "middle" | "end"]
   on the carousel wrapper of every slider track. CSS uses this to render
   edge-fades and touch-hint chevrons on the side that has off-screen
   content (i.e. only where the user can still scroll).
   Infinite-loop sliders are always semantically "middle" — wrap-around
   means the user can always swipe in both directions. */
(function () {
  const TRACK_SEL = '.ne-pg__track, .ne-tl__track, .ne-gg__track, .ne-cg__track';
  function isLoopCarousel(carousel) {
    return carousel.getAttribute('data-tl-loop') === '1'
        || carousel.getAttribute('data-gg-loop') === '1'
        || carousel.getAttribute('data-pg-loop') === '1'
        || carousel.getAttribute('data-cg-loop') === '1';
  }
  function edgeOf(track, isLoop) {
    const max = track.scrollWidth - track.clientWidth;
    if (max <= 4) return 'none';
    if (isLoop) return 'middle';
    /* Threshold of 8px tolerates subpixel drift introduced by % padding
       and scroll-snap rounding. Any further than this and we're truly
       past the snap-point. */
    if (track.scrollLeft <= 8) return 'start';
    if (track.scrollLeft >= max - 8) return 'end';
    return 'middle';
  }
  function update(track) {
    const carousel = track.closest('.ne-pg__carousel, .ne-tl__carousel, .ne-gg__carousel, .ne-cg__carousel');
    if (!carousel) return;
    const e = edgeOf(track, isLoopCarousel(carousel));
    if (carousel.getAttribute('data-edge') !== e) carousel.setAttribute('data-edge', e);
  }
  function bindTracks(root) {
    (root || document).querySelectorAll(TRACK_SEL).forEach((t) => {
      if (t.__neEdgeBound) return;
      t.__neEdgeBound = true;
      const sync = () => update(t);
      sync();
      /* Scroll-active marker: set [data-scrolling] on the track during
         REAL user scroll (touch / non-trivial deltas), remove on
         scrollend (or 60ms debounce). CSS hooks into this to render
         edge-fade masks ONLY while actively swiping, so resting cards
         keep their full shadow/glow effects intact.
         Filter snap-correction micro-scrolls (delta ≤ 4px after a snap
         lands) — those would otherwise re-enter scrolling state for a
         frame, leaving a flicker of the fade mask post-settle. */
      let scrollEndTimer = null;
      let lastScrollLeft = t.scrollLeft;
      const stopMark = () => {
        if (scrollEndTimer) { clearTimeout(scrollEndTimer); scrollEndTimer = null; }
        t.removeAttribute('data-scrolling');
      };
      const markScrolling = () => {
        if (!t.hasAttribute('data-scrolling')) t.setAttribute('data-scrolling', '');
        if (scrollEndTimer) clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(stopMark, 60);
      };
      t.addEventListener('scroll', () => {
        sync();
        const delta = Math.abs(t.scrollLeft - lastScrollLeft);
        lastScrollLeft = t.scrollLeft;
        if (delta > 4) markScrolling();
      }, { passive: true });
      /* Touchstart always marks — user-initiated even before scroll fires. */
      t.addEventListener('touchstart', markScrolling, { passive: true });
      if ('onscrollend' in window) {
        t.addEventListener('scrollend', stopMark, { passive: true });
      }
      window.addEventListener('resize', sync);
      /* Re-measure once any media inside has loaded — affects scrollWidth. */
      t.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', sync, { once: true });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindTracks(document));
  } else {
    bindTracks(document);
  }
  document.addEventListener('shopify:section:load', (e) => bindTracks(e.target));
  document.addEventListener('shopify:block:load', (e) => bindTracks(e.target));
})();

/* Mobile touch-hint: fade out after first user interaction with any slider track. */
(function () {
  if (!document.body.classList.contains('ne-touch-hint-active')) return;
  if (window.matchMedia && !window.matchMedia('(max-width: 599px)').matches) return;

  const TRACK_SEL = '.ne-pg__track, .ne-tl__track, .ne-gg__track, .ne-cg__track';
  let dismissed = false;
  function dismiss() {
    if (dismissed) return;
    dismissed = true;
    document.body.setAttribute('data-ne-hinted', '');
  }
  function bindTracks(root) {
    (root || document).querySelectorAll(TRACK_SEL).forEach((t) => {
      if (t.__neHintBound) return;
      t.__neHintBound = true;
      t.addEventListener('scroll', dismiss, { once: true, passive: true });
      t.addEventListener('touchstart', dismiss, { once: true, passive: true });
      t.addEventListener('pointerdown', dismiss, { once: true, passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindTracks(document));
  } else {
    bindTracks(document);
  }
  document.addEventListener('shopify:section:load', (e) => bindTracks(e.target));
  document.addEventListener('shopify:block:load', (e) => bindTracks(e.target));
})();

/* ─────────────────────────────────────────────────────────────────────────
   Image blur-up (LQIP) — theme setting "Image blur-up placeholder".
   Sets a tiny (24px) version of each image as the <img>'s OWN background and
   gaussian-blurs it, so the box shows a SMOOTH (not pixelated) blurred preview
   while the full image streams in, then the filter eases to 0 over the sharp
   pixels ("comes into focus"). Non-destructive: no DOM or layout change,
   inline filter/transform/background only, all cleared on load (so transparent
   PNGs don't show a fill behind their transparent areas). Skips UI imagery (header/footer,
   icons, logos, swatches, payment) and sections with their own placeholder
   system (parallax, cursor-fx). Covers AJAX-injected images via an observer.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  if (!document.body || document.body.getAttribute('data-ne-blur-up') !== '1') return;

  var SKIP_SEL = '.ne-header, .ne-footer, .ne-footer-bar-section, .ne-px, .ne-fx';
  var SKIP_CLASS = /icon|logo|swatch|payment|avatar|social|spinner|qr-/i;

  function lqip(src) {
    try {
      var abs = src.indexOf('//') === 0 ? location.protocol + src : src;
      var u = new URL(abs, location.href);
      if (u.pathname.indexOf('/cdn/shop/') === -1) return null;   // Shopify-CDN images only
      u.searchParams.set('width', '24');
      u.searchParams.delete('height');                            // keep native aspect ratio
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) { return null; }
  }

  function apply(img) {
    if (img.dataset.neLqip || img.hasAttribute('data-no-lqip')) return;
    if (SKIP_CLASS.test(img.className || '')) return;
    if (img.closest && img.closest(SKIP_SEL)) return;
    if (img.complete && img.naturalWidth) return;                 // already loaded
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) return;
    var lq = lqip(src);
    if (!lq) return;
    img.dataset.neLqip = '1';
    img.style.backgroundImage = "url('" + lq + "')";
    img.style.backgroundSize = 'cover';
    img.style.backgroundPosition = 'center';
    img.style.backgroundRepeat = 'no-repeat';
    // Smooth (not pixelated) preview: gaussian-blur the upscaled tiny image; a
    // slight scale hides the blur's edge fade under the parent's clip. While the
    // real image is unloaded the filter only affects the background. On load the
    // filter eases back to 0 over the now-sharp pixels → "comes into focus".
    img.style.filter = 'blur(12px)';
    img.style.transform = 'scale(1.06)';
    img.style.transition = 'filter 0.5s ease, transform 0.5s ease';
    var clear = function () {
      img.style.backgroundImage = 'none';
      img.style.filter = '';
      img.style.transform = '';
      window.setTimeout(function () { img.style.transition = ''; }, 600);
    };
    img.addEventListener('load', clear, { once: true });
    img.addEventListener('error', clear, { once: true });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) apply(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else { scan(document); }

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') apply(n);
          else scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* ── Per-block / per-section parallax driver (advanced settings → "Parallax") ─
   Generic scroll-driven drift/rotate/zoom for any element carrying
   .ne-block-adv--scroll (block, adv_parallax) or .ne-section-adv--scroll
   (section, sadv_parallax). Extracted from sections/scroll-parallax.liquid:
   drive ∈ [-1,1] from the element's own viewport position (center above mid → +,
   below → −), 0 at viewport centre. Writes FRAME vars (--ne-scroll-tx/ty/rotv/
   scalev) — NOT style.transform — so it composes with the persistent
   .ne-block-adv / .ne-section-adv transform (critical.css).
   Config vars on the element (emitted by block-advanced / section-advanced):
     --ne-scroll-dx / --ne-scroll-dy  drift % (−100..100, × ~200px travel)
     --ne-scroll-rot                  rotation degrees at the extremes
     --ne-scroll-zoom                 zoom % (scale at the extremes)
     --ne-scroll-lock                 1 = clamp the post-centre (+) phase to 0, so
                                      the element parallaxes IN to its resting
                                      position at viewport centre and then locks
                                      there instead of drifting onward.
   prefers-reduced-motion → no driver (element stays at its resting transform). */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = [];
  var ticking = false;
  function num(el, name) { var v = parseFloat(getComputedStyle(el).getPropertyValue(name)); return isNaN(v) ? 0 : v; }
  function scan() {
    items = [];
    var els = document.querySelectorAll('.ne-block-adv--scroll, .ne-section-adv--scroll');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      /* Zoom-parallax overscan (Rule 448 cont.): a fill image that zooms OUT at
         the scroll extreme shrinks below the tile and reveals its edges (the
         Liquid inset only overscans TRANSLATE drift, not zoom). Counter it with a
         constant base scale = 1/(1 - |zoom|/100) so the minimum effective scale
         lands at 1.0 (exactly covering). Scoped to fill images so text/other
         blocks that zoom on scroll are untouched. Capped at 3x for sanity. */
      var zoom = num(el, '--ne-scroll-zoom');
      var zAbs = Math.abs(zoom);
      var fill = el.classList.contains('ne-block-image-wrap--fill');
      var zos = (fill && zAbs > 0 && zAbs < 100) ? (1 / (1 - zAbs / 100)) : 1;
      if (zos > 3) zos = 3;
      items.push({ el: el, dx: num(el, '--ne-scroll-dx'), dy: num(el, '--ne-scroll-dy'), rot: num(el, '--ne-scroll-rot'), zoom: zoom, zos: zos, lock: num(el, '--ne-scroll-lock'), bluramt: num(el, '--ne-scroll-bluramt'), fadeamt: num(el, '--ne-scroll-fadeamt') });
    }
  }
  function apply() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    /* ⚠️ ZWEI DURCHGAENGE, und das ist kein Stil, sondern der Kern der Sache.
       Vorher stand in EINER Schleife lesen → schreiben → lesen → schreiben: jedes
       `getBoundingClientRect` nach einem `setProperty` zwingt den Browser, den Stil
       sofort neu zu rechnen, statt es bis zum Frame-Ende zu sammeln (Rule 534).
       Gemessen an 21rebel am 2026-07-30: von 51 erzwungenen Neuberechnungen waehrend
       20 Scrollschritten waren 22 die Folge „getBoundingClientRect nach
       --ne-scroll-scalev" — alle aus dieser Schleife, und damit der groesste
       verbliebene Posten, nachdem der Header seine Messung losgeworden war.
       Erst alle Positionen einlesen, dann alle Werte schreiben: aus einer
       Neuberechnung je Element wird eine je Frame.
       ⚠️ `drive` darf 0 sein (Ruhelage in der Mitte), deshalb markiert `null` das
       Ueberspringen und nicht ein falsy-Test. */
    var werte = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var r = it.el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) { werte.push(null); continue; } /* skip far off-screen */
      var drive = (vh / 2 - (r.top + r.height / 2)) / (vh * 0.6);
      if (drive > 1) drive = 1; else if (drive < -1) drive = -1;
      /* Lock at centre: suppress the post-centre (+) phase so the element settles
         at its resting position (drive 0) once it reaches the viewport middle. */
      if (it.lock && drive > 0) drive = 0;
      werte.push(drive);
    }
    for (var j = 0; j < items.length; j++) {
      var d = werte[j];
      if (d === null) continue;
      var el = items[j];
      var s = el.el.style;
      s.setProperty('--ne-scroll-tx', (d * (el.dx / 100) * 200).toFixed(1) + 'px');
      s.setProperty('--ne-scroll-ty', (d * (el.dy / 100) * 200).toFixed(1) + 'px');
      s.setProperty('--ne-scroll-rotv', (d * el.rot).toFixed(2) + 'deg');
      var sv = el.zos * (1 + d * (el.zoom / 100));
      if (sv < 0.1) sv = 0.1;
      s.setProperty('--ne-scroll-scalev', sv.toFixed(3));
      /* Blur / opacity scale with |drive|: sharp + opaque at centre (drive 0),
         blurred + faded toward the extremes (with lock, the post-centre phase is
         already clamped to 0 → stays sharp/opaque once settled). */
      if (el.bluramt) s.setProperty('--ne-scroll-blur', (el.bluramt * Math.abs(d)).toFixed(2) + 'px');
      if (el.fadeamt) s.setProperty('--ne-scroll-opacity', (1 - (el.fadeamt / 100) * Math.abs(d)).toFixed(3));
    }
  }
  function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(apply); }
  function init() {
    // Always attach the listener (cheap no-op loop when there are no parallax
    // blocks) so blocks added later via the Customizer (shopify:section:load
    // re-scan) start animating without a reload.
    scan();
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }
  document.addEventListener('shopify:section:load', function () { scan(); apply(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
